// // screens/marketplace/PreOrderCampaignDetail.jsx
// import React, { useCallback, useEffect, useMemo, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import {
//   ChevronLeft,
//   Clock,
//   Package,
//   ShoppingCart,
//   ShoppingBag,
//   AlertCircle,
//   RefreshCw,
//   CalendarDays,
//   Truck,
//   Check,
// } from "lucide-react";
// import { useAuth } from "../../providers/AuthProvider";
// import { useTheme } from "../../hooks/useTheme";
// import { useToast } from "../../providers/ToastProvider";
// import { useCart } from "../../contexts/CartContext";

// const money = (v) => `₵${Number(v || 0).toFixed(2)}`;

// const daysBetween = (a, b) => Math.ceil((b - a) / 86400000);

// const fmtDate = (iso) =>
//   new Date(iso).toLocaleDateString(undefined, {
//     weekday: "short",
//     month: "short",
//     day: "numeric",
//   });

// const fmtDateTime = (iso) =>
//   new Date(iso).toLocaleString(undefined, {
//     month: "short",
//     day: "numeric",
//     hour: "2-digit",
//     minute: "2-digit",
//   });

// export default function PreOrderCampaignDetail() {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const { authFetch, isAuthenticated } = useAuth();
//   const { colors } = useTheme();
//   const { showToast } = useToast();

//   const [campaign, setCampaign] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [addingTo, setAddingTo] = useState(null);
//   const [added, setAdded] = useState(() => new Set());
//   const [now, setNow] = useState(Date.now());
//   const { increment: incrementCart } = useCart();
  

//   useEffect(() => {
//     const t = setInterval(() => setNow(Date.now()), 60_000);
//     return () => clearInterval(t);
//   }, []);

//   const load = useCallback(async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const res = await authFetch(`/marketplace/pre-orders/${id}/`);
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message || "Could not load campaign");
//       setCampaign(data.data);
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   }, [authFetch, id]);

//   useEffect(() => {
//     load();
//   }, [load]);

//   const items = useMemo(
//     () => campaign?.products || campaign?.pre_order_products || [],
//     [campaign]
//   );

//   const phase = useMemo(() => {
//     if (!campaign) return null;
//     const start = new Date(campaign.start_date).getTime();
//     const end = new Date(campaign.end_date).getTime();
//     if (!campaign.is_active) return "closed";
//     if (now < start) return "upcoming";
//     if (now > end) return "closed";
//     return "open";
//   }, [campaign, now]);

//   const canOrder = phase === "open";

//   const addToCart = async (item, e) => {
//     e?.stopPropagation();
//     if (!isAuthenticated) {
//       navigate(`/login?next=/preorder/campaigns/${id}`);
//       return;
//     }
//     setAddingTo(item.id);
//     try {
//       const res = await authFetch("/marketplace/cart/add/", {
//         method: "POST",
//         body: JSON.stringify({
//           product: item.product,
//           quantity: 1,
//           item_type: "PRE_ORDER",
//           pre_order: campaign.id,
//         }),
//       });
//       const data = await res.json();
//       if (!res.ok) {
//         throw new Error(
//           data.message ||
//             Object.values(data.errors || {}).flat().join(" ") ||
//             "Could not add to cart"
//         );
//       }
//       showToast("Added to your pre-order cart", "success");
//       setAdded((prev) => new Set(prev).add(item.id));
//       incrementCart(1);
//     } catch (err) {
//       showToast(err.message, "error");
//     } finally {
//       setAddingTo(null);
//     }
//   };

//   /* ── Loading / error ──────────────────────────────── */
//   if (loading) {
//     return (
//       <div style={styles.loadingWrap(colors)}>
//         <div style={styles.spinner(colors)} />
//         <span style={{ color: colors.secondaryText, fontSize: 13 }}>
//           Loading window…
//         </span>
//       </div>
//     );
//   }

//   if (error || !campaign) {
//     return (
//       <div style={styles.pageWrap}>
//         <button
//           type="button"
//           onClick={() => navigate("/preorder")}
//           style={styles.backBtn(colors)}
//         >
//           <ChevronLeft size={16} /> All windows
//         </button>
//         <div style={styles.errorWrap(colors)}>
//           <div style={styles.errorIcon(colors)}>
//             <AlertCircle size={26} />
//           </div>
//           <h2 style={styles.errorTitle(colors)}>Campaign not available</h2>
//           <p style={styles.errorText(colors)}>
//             {error || "This pre-order window may have been removed."}
//           </p>
//           <button
//             type="button"
//             onClick={() => navigate("/preorder")}
//             style={styles.primaryBtn(colors)}
//           >
//             Back to pre-order windows
//           </button>
//         </div>
//       </div>
//     );
//   }

//   /* ── Derived state for header ─────────────────────── */
//   const start = new Date(campaign.start_date).getTime();
//   const end = new Date(campaign.end_date).getTime();
//   const daysLeft = Math.max(0, daysBetween(now, end));
//   const daysUntilStart = Math.max(0, daysBetween(now, start));
//   const availableCount = items.filter(
//     (i) => i.is_available && (i.stock_limit === 0 || i.sold_count < i.stock_limit)
//   ).length;

//   const headerTone = {
//     open: { fg: colors.success, bg: colors.successBg, label: "Open now" },
//     upcoming: { fg: colors.warning, bg: colors.warningBg, label: "Opens soon" },
//     closed: { fg: colors.secondaryText, bg: colors.hoverBg, label: "Closed" },
//   }[phase];

//   return (
//     <div style={styles.pageWrap}>
//       {/* Back */}
//       <button
//         type="button"
//         onClick={() => navigate("/preorder")}
//         style={styles.backBtn(colors)}
//       >
//         <ChevronLeft size={16} /> All windows
//       </button>

//       {/* Hero */}
//       <section style={styles.hero(colors)}>
//         <div style={styles.heroTop}>
//           <span
//             style={{
//               ...styles.heroChip,
//               background: headerTone.bg,
//               color: headerTone.fg,
//             }}
//           >
//             <Clock size={12} />
//             {headerTone.label}
//             {phase === "open" && daysLeft > 0 && (
//               <> · {daysLeft === 0 ? "closing today" : `${daysLeft} day${daysLeft === 1 ? "" : "s"} left`}</>
//             )}
//             {phase === "upcoming" && (
//               <> · {daysUntilStart === 0 ? "opens today" : `in ${daysUntilStart} day${daysUntilStart === 1 ? "" : "s"}`}</>
//             )}
//           </span>

//           <div style={styles.heroMeta(colors)}>
//             <CalendarDays size={13} />
//             <span>
//               {fmtDateTime(campaign.start_date)} → {fmtDateTime(campaign.end_date)}
//             </span>
//           </div>
//         </div>

//         <h1 style={styles.heroTitle(colors)}>{campaign.name}</h1>
//         {campaign.description && (
//           <p style={styles.heroDesc(colors)}>{campaign.description}</p>
//         )}

//         <div style={styles.heroStats}>
//           <StatChip
//             icon={Package}
//             label={`${items.length} product${items.length === 1 ? "" : "s"}`}
//             colors={colors}
//           />
//           <StatChip
//             icon={Check}
//             label={`${availableCount} available`}
//             colors={colors}
//           />
//           <StatChip
//             icon={Truck}
//             label="Ships together at close"
//             colors={colors}
//           />
//         </div>

//         {phase === "upcoming" && (
//           <div style={styles.banner(colors, "info")}>
//             <Clock size={15} />
//             This window hasn't opened yet. Products below are shown as a
//             preview — you'll be able to order once it opens on{" "}
//             <strong>{fmtDate(campaign.start_date)}</strong>.
//           </div>
//         )}
//         {phase === "closed" && (
//           <div style={styles.banner(colors, "muted")}>
//             <AlertCircle size={15} />
//             This window closed on <strong>{fmtDate(campaign.end_date)}</strong>.
//             Products below are shown for reference only.
//           </div>
//         )}
//       </section>

//       {/* Products */}
//       <section style={{ marginTop: 24 }}>
//         <div style={styles.gridHeader}>
//           <h2 style={styles.gridTitle(colors)}>
//             {phase === "open"
//               ? "Products in this window"
//               : phase === "upcoming"
//               ? "What's coming"
//               : "What was offered"}
//           </h2>
//           <span style={styles.gridCount(colors)}>
//             {items.length} item{items.length === 1 ? "" : "s"}
//           </span>
//         </div>

//         {items.length === 0 ? (
//           <div style={styles.emptyGrid(colors)}>
//             <Package size={22} />
//             <p style={{ margin: "10px 0 0", fontSize: 13 }}>
//               No products have been added to this window yet.
//             </p>
//           </div>
//         ) : (
//           <div style={styles.grid}>
//             {items.map((item) => (
//               <PreOrderProductCard
//                 key={item.id}
//                 item={item}
//                 phase={phase}
//                 addingTo={addingTo}
//                 added={added.has(item.id)}
//                 colors={colors}
//                 onAdd={(e) => addToCart(item, e)}
//                 onOpen={() =>
//                   navigate(`/marketplace/products/${item.product}`)
//                 }
//               />
//             ))}
//           </div>
//         )}
//       </section>

//       <style>{`
//         @keyframes spin { to { transform: rotate(360deg); } }
//       `}</style>
//     </div>
//   );
// }

// /* ══════════════════════════════════════════════════════════
//    Product card inside campaign
//    ══════════════════════════════════════════════════════════ */

// const PreOrderProductCard = ({
//   item,
//   phase,
//   addingTo,
//   added,
//   colors,
//   onAdd,
//   onOpen,
// }) => {
//   const productImage =
//     item.product_images?.[0]?.image ||
//     item.product_images?.[0]?.url ||
//     null;

//   const soldOut =
//     item.stock_limit > 0 && item.sold_count >= item.stock_limit;
//   const canBuy = phase === "open" && item.is_available && !soldOut;

//   const chipState = (() => {
//     if (phase === "upcoming")
//       return { label: "Opens soon", fg: colors.warning, bg: colors.warningBg, icon: Clock };
//     if (phase === "closed")
//       return { label: "Window closed", fg: colors.secondaryText, bg: colors.hoverBg, icon: Clock };
//     if (soldOut)
//       return { label: "Sold out", fg: colors.error, bg: colors.errorBg, icon: AlertCircle };
//     if (!item.is_available)
//       return { label: "Unavailable", fg: colors.secondaryText, bg: colors.hoverBg, icon: AlertCircle };
//     return { label: "Pre-order", fg: colors.warning, bg: colors.warningBg, icon: Clock };
//   })();
//   const ChipIcon = chipState.icon;

//   const stockLabel =
//     item.stock_limit > 0
//       ? `${item.stock_limit - item.sold_count} of ${item.stock_limit} left`
//       : "Unlimited";

//   return (
//     <article
//       onClick={onOpen}
//       style={styles.card(colors)}
//       onMouseEnter={(e) => {
//         e.currentTarget.style.transform = "translateY(-3px)";
//         e.currentTarget.style.borderColor = colors.btnBg;
//         e.currentTarget.style.boxShadow = `0 12px 32px ${colors.shadow}`;
//       }}
//       onMouseLeave={(e) => {
//         e.currentTarget.style.transform = "translateY(0)";
//         e.currentTarget.style.borderColor = colors.border;
//         e.currentTarget.style.boxShadow = "none";
//       }}
//     >
//       <div style={styles.cardMedia(colors)}>
//         {productImage ? (
//           <img
//             src={productImage}
//             alt={item.product_name}
//             loading="lazy"
//             style={styles.cardImg}
//           />
//         ) : (
//           <div style={styles.cardImgPlaceholder(colors)}>
//             <Package size={26} />
//           </div>
//         )}

//         <span
//           style={{
//             position: "absolute",
//             top: 10,
//             left: 10,
//             display: "inline-flex",
//             alignItems: "center",
//             gap: 4,
//             padding: "4px 10px",
//             borderRadius: 999,
//             background: chipState.bg,
//             color: chipState.fg,
//             fontSize: 10.5,
//             fontWeight: 700,
//             letterSpacing: 0.2,
//             textTransform: "uppercase",
//             backdropFilter: "blur(6px)",
//           }}
//         >
//           <ChipIcon size={10} />
//           {chipState.label}
//         </span>

//         {item.stock_limit > 0 && phase === "open" && (
//           <span
//             style={{
//               position: "absolute",
//               bottom: 10,
//               left: 10,
//               padding: "3px 9px",
//               borderRadius: 999,
//               background: "rgba(0,0,0,0.6)",
//               color: "#fff",
//               fontSize: 10.5,
//               fontWeight: 700,
//               backdropFilter: "blur(6px)",
//             }}
//           >
//             {stockLabel}
//           </span>
//         )}
//       </div>

//       <div style={styles.cardBody}>
//         <h3 style={styles.cardTitle(colors)}>{item.product_name}</h3>

//         <div style={styles.cardPriceRow}>
//           <span style={styles.cardPrice(colors)}>
//             {money(item.effective_price || item.price_customer)}
//           </span>
//         </div>

//         <button
//           type="button"
//           disabled={!canBuy || addingTo === item.id || added}
//           onClick={onAdd}
//           style={styles.cardBtn(colors, canBuy, added)}
//         >
//           {added ? (
//             <>
//               <Check size={14} /> Added
//             </>
//           ) : addingTo === item.id ? (
//             <>
//               <RefreshCw
//                 size={14}
//                 style={{ animation: "spin 0.9s linear infinite" }}
//               />{" "}
//               Adding…
//             </>
//           ) : (
//             <>
//               <ShoppingBag size={14} />
//               {phase === "open"
//                 ? soldOut
//                   ? "Sold out"
//                   : "Join pre-order"
//                 : phase === "upcoming"
//                 ? "Not yet open"
//                 : "Window closed"}
//             </>
//           )}
//         </button>
//       </div>
//     </article>
//   );
// };

// const StatChip = ({ icon: Icon, label, colors }) => (
//   <span
//     style={{
//       display: "inline-flex",
//       alignItems: "center",
//       gap: 6,
//       padding: "6px 11px",
//       borderRadius: 999,
//       background: colors.raisedBg,
//       border: `1px solid ${colors.border}`,
//       color: colors.secondaryText,
//       fontSize: 12,
//       fontWeight: 600,
//     }}
//   >
//     <Icon size={12} />
//     {label}
//   </span>
// );

// /* ══════════════════════════════════════════════════════════
//    Styles
//    ══════════════════════════════════════════════════════════ */

// const styles = {
//   pageWrap: {
//     maxWidth: 1180,
//     margin: "0 auto",
//     padding: "16px 16px 64px",
//   },
//   loadingWrap: (c) => ({
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     justifyContent: "center",
//     minHeight: 340,
//     gap: 12,
//   }),
//   spinner: (c) => ({
//     width: 32,
//     height: 32,
//     border: `3px solid ${c.border}`,
//     borderTopColor: c.btnBg,
//     borderRadius: "50%",
//     animation: "spin 0.9s linear infinite",
//   }),
//   backBtn: (c) => ({
//     display: "inline-flex",
//     alignItems: "center",
//     gap: 4,
//     background: "transparent",
//     border: "none",
//     color: c.secondaryText,
//     cursor: "pointer",
//     padding: "6px 0",
//     marginBottom: 14,
//     fontSize: 13,
//     fontWeight: 600,
//   }),

//   hero: (c) => ({
//     background: c.raisedBg,
//     border: `1px solid ${c.border}`,
//     borderRadius: 18,
//     padding: "22px 24px",
//     display: "flex",
//     flexDirection: "column",
//     gap: 14,
//   }),
//   heroTop: {
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "space-between",
//     gap: 12,
//     flexWrap: "wrap",
//   },
//   heroChip: {
//     display: "inline-flex",
//     alignItems: "center",
//     gap: 6,
//     padding: "5px 12px",
//     borderRadius: 999,
//     fontSize: 11.5,
//     fontWeight: 700,
//     letterSpacing: 0.2,
//   },
//   heroMeta: (c) => ({
//     display: "inline-flex",
//     alignItems: "center",
//     gap: 6,
//     fontSize: 12.5,
//     color: c.secondaryText,
//   }),
//   heroTitle: (c) => ({
//     margin: 0,
//     fontSize: "clamp(22px, 3.4vw, 30px)",
//     fontWeight: 800,
//     letterSpacing: "-0.02em",
//     lineHeight: 1.15,
//     color: c.heading,
//   }),
//   heroDesc: (c) => ({
//     margin: 0,
//     fontSize: 14,
//     lineHeight: 1.6,
//     color: c.secondaryText,
//     maxWidth: 640,
//   }),
//   heroStats: {
//     display: "flex",
//     flexWrap: "wrap",
//     gap: 8,
//     marginTop: 4,
//   },

//   banner: (c, tone) => ({
//     display: "flex",
//     alignItems: "flex-start",
//     gap: 10,
//     padding: "10px 14px",
//     borderRadius: 10,
//     background: tone === "info" ? c.hoverBg : c.hoverBg,
//     color: c.secondaryText,
//     fontSize: 12.5,
//     lineHeight: 1.5,
//     marginTop: 4,
//   }),

//   gridHeader: {
//     display: "flex",
//     alignItems: "baseline",
//     justifyContent: "space-between",
//     gap: 10,
//     marginBottom: 14,
//   },
//   gridTitle: (c) => ({
//     margin: 0,
//     fontSize: 15,
//     fontWeight: 800,
//     color: c.heading,
//     letterSpacing: "-0.01em",
//   }),
//   gridCount: (c) => ({
//     fontSize: 12.5,
//     color: c.secondaryText,
//   }),
//   grid: {
//     display: "grid",
//     gridTemplateColumns: "repeat(auto-fill, minmax(230px, 1fr))",
//     gap: 16,
//   },
//   emptyGrid: (c) => ({
//     padding: "40px 24px",
//     textAlign: "center",
//     color: c.secondaryText,
//     border: `1px dashed ${c.border}`,
//     borderRadius: 14,
//   }),

//   card: (c) => ({
//     background: c.raisedBg,
//     border: `1px solid ${c.border}`,
//     borderRadius: 14,
//     overflow: "hidden",
//     cursor: "pointer",
//     display: "flex",
//     flexDirection: "column",
//     transition: "transform 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
//   }),
//   cardMedia: (c) => ({
//     position: "relative",
//     aspectRatio: "4 / 3",
//     background: c.hoverBg,
//     overflow: "hidden",
//   }),
//   cardImg: {
//     width: "100%",
//     height: "100%",
//     objectFit: "cover",
//     display: "block",
//   },
//   cardImgPlaceholder: (c) => ({
//     width: "100%",
//     height: "100%",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     color: c.secondaryText,
//   }),
//   cardBody: {
//     padding: 14,
//     display: "flex",
//     flexDirection: "column",
//     gap: 8,
//     flex: 1,
//   },
//   cardTitle: (c) => ({
//     margin: 0,
//     fontSize: 14.5,
//     fontWeight: 700,
//     color: c.heading,
//     lineHeight: 1.35,
//     display: "-webkit-box",
//     WebkitLineClamp: 2,
//     WebkitBoxOrient: "vertical",
//     overflow: "hidden",
//     minHeight: 38,
//   }),
//   cardPriceRow: {
//     display: "flex",
//     alignItems: "baseline",
//     justifyContent: "space-between",
//     gap: 6,
//     marginTop: "auto",
//   },
//   cardPrice: (c) => ({
//     fontSize: 18,
//     fontWeight: 800,
//     color: c.heading,
//     letterSpacing: "-0.02em",
//   }),
//   cardBtn: (c, enabled, added) => ({
//     display: "inline-flex",
//     alignItems: "center",
//     justifyContent: "center",
//     gap: 6,
//     padding: "9px 12px",
//     borderRadius: 10,
//     border: "none",
//     background: added
//       ? c.successBg
//       : enabled
//       ? c.btnBg
//       : c.hoverBg,
//     color: added
//       ? c.success
//       : enabled
//       ? c.btnText
//       : c.secondaryText,
//     fontSize: 13,
//     fontWeight: 700,
//     cursor: enabled ? "pointer" : "not-allowed",
//     transition: "transform 0.15s ease, background 0.15s ease",
//   }),

//   errorWrap: (c) => ({
//     maxWidth: 380,
//     margin: "60px auto",
//     textAlign: "center",
//     padding: 24,
//   }),
//   errorIcon: (c) => ({
//     width: 64,
//     height: 64,
//     borderRadius: 20,
//     background: c.hoverBg,
//     color: c.secondaryText,
//     display: "inline-flex",
//     alignItems: "center",
//     justifyContent: "center",
//     marginBottom: 16,
//   }),
//   errorTitle: (c) => ({
//     margin: "0 0 6px",
//     fontSize: 18,
//     fontWeight: 800,
//     color: c.heading,
//   }),
//   errorText: (c) => ({
//     margin: "0 0 22px",
//     fontSize: 13.5,
//     color: c.secondaryText,
//     lineHeight: 1.55,
//   }),
//   primaryBtn: (c) => ({
//     padding: "11px 20px",
//     borderRadius: 10,
//     border: "none",
//     background: c.btnBg,
//     color: c.btnText,
//     fontWeight: 700,
//     fontSize: 13.5,
//     cursor: "pointer",
//   }),
// };









































// screens/marketplace/PreOrderCampaignDetail.jsx
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  ChevronLeft,
  Clock,
  Package,
  ShoppingBag,
  AlertCircle,
  RefreshCw,
  CalendarDays,
  Truck,
  Check,
  Layers,
} from "lucide-react";
import { useAuth } from "../../providers/AuthProvider";
import { useTheme } from "../../hooks/useTheme";
import { useToast } from "../../providers/ToastProvider";
import { useCart } from "../../contexts/CartContext";
import { variantKeyLabel } from "./pricingApi";

const money = (v) => `₵${Number(v || 0).toFixed(2)}`;

const daysBetween = (a, b) => Math.ceil((b - a) / 86400000);

const fmtDate = (iso) =>
  new Date(iso).toLocaleDateString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
  });

const fmtDateTime = (iso) =>
  new Date(iso).toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

export default function PreOrderCampaignDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { authFetch, isAuthenticated } = useAuth();
  const { colors } = useTheme();
  const { showToast } = useToast();
  const { increment: incrementCart } = useCart();

  const [campaign, setCampaign] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [addingTo, setAddingTo] = useState(null);
  const [added, setAdded] = useState(() => new Set());
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 60_000);
    return () => clearInterval(t);
  }, []);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await authFetch(`/marketplace/pre-orders/${id}/`);
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Could not load campaign");
      setCampaign(data.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [authFetch, id]);

  useEffect(() => {
    load();
  }, [load]);

  const items = useMemo(
    () => campaign?.products || campaign?.pre_order_products || [],
    [campaign]
  );

  const phase = useMemo(() => {
    if (!campaign) return null;
    const start = new Date(campaign.start_date).getTime();
    const end = new Date(campaign.end_date).getTime();
    if (!campaign.is_active) return "closed";
    if (now < start) return "upcoming";
    if (now > end) return "closed";
    return "open";
  }, [campaign, now]);

  const addToCart = async (item, e) => {
    e?.stopPropagation();
    if (!isAuthenticated) {
      navigate(`/login?next=/preorder/campaigns/${id}`);
      return;
    }

    // If the campaign item targets a specific variant, we send that key
    // through to the cart. The buyer doesn't need to pick anything on
    // this page because the campaign already pinned the variant.
    //
    // If the item has no variant_key but the underlying product does,
    // we can't add from here — the user must go to the product page
    // to pick their variant. The card handles this via the button label
    // and by routing on click, so this function should never be reached
    // in that case. The check is defensive.
    if (item.has_variants && !item.variant_key) {
      navigate(`/marketplace/products/${item.product}`);
      return;
    }

    setAddingTo(item.id);
    try {
      const body = {
        product: item.product,
        quantity: 1,
        item_type: "PRE_ORDER",
        pre_order: campaign.id,
      };
      if (item.variant_key) body.variant_key = item.variant_key;

      const res = await authFetch("/marketplace/cart/add/", {
        method: "POST",
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(
          data.message ||
            Object.values(data.errors || {}).flat().join(" ") ||
            "Could not add to cart"
        );
      }
      showToast("Added to your pre-order cart", "success");
      setAdded((prev) => new Set(prev).add(item.id));
      incrementCart(1);
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setAddingTo(null);
    }
  };

  /* ── Loading / error ──────────────────────────────── */
  if (loading) {
    return (
      <div style={styles.loadingWrap(colors)}>
        <div style={styles.spinner(colors)} />
        <span style={{ color: colors.secondaryText, fontSize: 13 }}>
          Loading window…
        </span>
      </div>
    );
  }

  if (error || !campaign) {
    return (
      <div style={styles.pageWrap}>
        <button
          type="button"
          onClick={() => navigate("/preorder")}
          style={styles.backBtn(colors)}
        >
          <ChevronLeft size={16} /> All windows
        </button>
        <div style={styles.errorWrap(colors)}>
          <div style={styles.errorIcon(colors)}>
            <AlertCircle size={26} />
          </div>
          <h2 style={styles.errorTitle(colors)}>Campaign not available</h2>
          <p style={styles.errorText(colors)}>
            {error || "This pre-order window may have been removed."}
          </p>
          <button
            type="button"
            onClick={() => navigate("/preorder")}
            style={styles.primaryBtn(colors)}
          >
            Back to pre-order windows
          </button>
        </div>
      </div>
    );
  }

  /* ── Derived state for header ─────────────────────── */
  const start = new Date(campaign.start_date).getTime();
  const end = new Date(campaign.end_date).getTime();
  const daysLeft = Math.max(0, daysBetween(now, end));
  const daysUntilStart = Math.max(0, daysBetween(now, start));
  const availableCount = items.filter(
    (i) => i.is_available && (i.stock_limit === 0 || i.sold_count < i.stock_limit)
  ).length;

  const headerTone = {
    open: { fg: colors.success, bg: colors.successBg, label: "Open now" },
    upcoming: { fg: colors.warning, bg: colors.warningBg, label: "Opens soon" },
    closed: { fg: colors.secondaryText, bg: colors.hoverBg, label: "Closed" },
  }[phase];

  return (
    <div style={styles.pageWrap}>
      <button
        type="button"
        onClick={() => navigate("/preorder")}
        style={styles.backBtn(colors)}
      >
        <ChevronLeft size={16} /> All windows
      </button>

      {/* Hero */}
      <section style={styles.hero(colors)}>
        <div style={styles.heroTop}>
          <span
            style={{
              ...styles.heroChip,
              background: headerTone.bg,
              color: headerTone.fg,
            }}
          >
            <Clock size={12} />
            {headerTone.label}
            {phase === "open" && daysLeft > 0 && (
              <>
                {" · "}
                {daysLeft === 0
                  ? "closing today"
                  : `${daysLeft} day${daysLeft === 1 ? "" : "s"} left`}
              </>
            )}
            {phase === "upcoming" && (
              <>
                {" · "}
                {daysUntilStart === 0
                  ? "opens today"
                  : `in ${daysUntilStart} day${daysUntilStart === 1 ? "" : "s"}`}
              </>
            )}
          </span>

          <div style={styles.heroMeta(colors)}>
            <CalendarDays size={13} />
            <span>
              {fmtDateTime(campaign.start_date)} →{" "}
              {fmtDateTime(campaign.end_date)}
            </span>
          </div>
        </div>

        <h1 style={styles.heroTitle(colors)}>{campaign.name}</h1>
        {campaign.description && (
          <p style={styles.heroDesc(colors)}>{campaign.description}</p>
        )}

        <div style={styles.heroStats}>
          <StatChip
            icon={Package}
            label={`${items.length} product${items.length === 1 ? "" : "s"}`}
            colors={colors}
          />
          <StatChip
            icon={Check}
            label={`${availableCount} available`}
            colors={colors}
          />
          <StatChip
            icon={Truck}
            label="Ships together at close"
            colors={colors}
          />
        </div>

        {phase === "upcoming" && (
          <div style={styles.banner(colors, "info")}>
            <Clock size={15} />
            This window hasn't opened yet. Products below are shown as a
            preview — you'll be able to order once it opens on{" "}
            <strong>{fmtDate(campaign.start_date)}</strong>.
          </div>
        )}
        {phase === "closed" && (
          <div style={styles.banner(colors, "muted")}>
            <AlertCircle size={15} />
            This window closed on <strong>{fmtDate(campaign.end_date)}</strong>.
            Products below are shown for reference only.
          </div>
        )}
      </section>

      {/* Products */}
      <section style={{ marginTop: 24 }}>
        <div style={styles.gridHeader}>
          <h2 style={styles.gridTitle(colors)}>
            {phase === "open"
              ? "Products in this window"
              : phase === "upcoming"
              ? "What's coming"
              : "What was offered"}
          </h2>
          <span style={styles.gridCount(colors)}>
            {items.length} item{items.length === 1 ? "" : "s"}
          </span>
        </div>

        {items.length === 0 ? (
          <div style={styles.emptyGrid(colors)}>
            <Package size={22} />
            <p style={{ margin: "10px 0 0", fontSize: 13 }}>
              No products have been added to this window yet.
            </p>
          </div>
        ) : (
          <div style={styles.grid}>
            {items.map((item) => (
              <PreOrderProductCard
                key={item.id}
                item={item}
                phase={phase}
                addingTo={addingTo}
                added={added.has(item.id)}
                colors={colors}
                onAdd={(e) => addToCart(item, e)}
                onOpen={() =>
                  navigate(`/marketplace/products/${item.product}`)
                }
              />
            ))}
          </div>
        )}
      </section>

      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}

/* ══════════════════════════════════════════════════════════
   Product card inside campaign
   ══════════════════════════════════════════════════════════ */

const PreOrderProductCard = ({
  item,
  phase,
  addingTo,
  added,
  colors,
  onAdd,
  onOpen,
}) => {
  const productImage =
    item.product_images?.[0]?.image || item.product_images?.[0]?.url || null;

  const hasVariant = !!item.variant_key;
  // The campaign item itself targets no variant, but the underlying
  // product has variants. The buyer must go to the product page.
  const needsVariantPick = !!item.has_variants && !item.variant_key;

  const soldOut =
    item.stock_limit > 0 && item.sold_count >= item.stock_limit;

  const canBuyDirect =
    phase === "open" &&
    item.is_available &&
    !soldOut &&
    !needsVariantPick;

  const chipState = (() => {
    if (phase === "upcoming")
      return {
        label: "Opens soon",
        fg: colors.warning,
        bg: colors.warningBg,
        icon: Clock,
      };
    if (phase === "closed")
      return {
        label: "Window closed",
        fg: colors.secondaryText,
        bg: colors.hoverBg,
        icon: Clock,
      };
    if (soldOut)
      return {
        label: "Sold out",
        fg: colors.error,
        bg: colors.errorBg,
        icon: AlertCircle,
      };
    if (!item.is_available)
      return {
        label: "Unavailable",
        fg: colors.secondaryText,
        bg: colors.hoverBg,
        icon: AlertCircle,
      };
    if (needsVariantPick)
      return {
        label: "Options",
        fg: colors.linkColor,
        bg: colors.hoverBg,
        icon: Layers,
      };
    return {
      label: "Pre-order",
      fg: colors.warning,
      bg: colors.warningBg,
      icon: Clock,
    };
  })();
  const ChipIcon = chipState.icon;

  const stockLabel =
    item.stock_limit > 0
      ? `${item.stock_limit - item.sold_count} of ${item.stock_limit} left`
      : "Unlimited";

  const shippingFee = Number(item.shipping_fee || 0);

  return (
    <article
      onClick={onOpen}
      style={styles.card(colors)}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-3px)";
        e.currentTarget.style.borderColor = colors.btnBg;
        e.currentTarget.style.boxShadow = `0 12px 32px ${colors.shadow}`;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.borderColor = colors.border;
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <div style={styles.cardMedia(colors)}>
        {productImage ? (
          <img
            src={productImage}
            alt={item.product_name}
            loading="lazy"
            style={styles.cardImg}
          />
        ) : (
          <div style={styles.cardImgPlaceholder(colors)}>
            <Package size={26} />
          </div>
        )}

        <span
          style={{
            position: "absolute",
            top: 10,
            left: 10,
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
            padding: "4px 10px",
            borderRadius: 999,
            background: chipState.bg,
            color: chipState.fg,
            fontSize: 10.5,
            fontWeight: 700,
            letterSpacing: 0.2,
            textTransform: "uppercase",
            backdropFilter: "blur(6px)",
          }}
        >
          <ChipIcon size={10} />
          {chipState.label}
        </span>

        {item.stock_limit > 0 && phase === "open" && (
          <span
            style={{
              position: "absolute",
              bottom: 10,
              left: 10,
              padding: "3px 9px",
              borderRadius: 999,
              background: "rgba(0,0,0,0.6)",
              color: "#fff",
              fontSize: 10.5,
              fontWeight: 700,
              backdropFilter: "blur(6px)",
            }}
          >
            {stockLabel}
          </span>
        )}
      </div>

      <div style={styles.cardBody}>
        <div style={{ minWidth: 0 }}>
          <h3 style={styles.cardTitle(colors)}>{item.product_name}</h3>

          {/* Variant chip — only shown when the campaign item targets
              a specific variant. */}
          {hasVariant && (
            <span style={styles.variantChip(colors)}>
              <Layers size={10} />
              {variantKeyLabel(item.variant_key)}
            </span>
          )}

          {/* Shipping hint */}
          {shippingFee > 0 && (
            <div style={styles.shippingHint(colors)}>
              <Truck size={10} /> +{money(shippingFee)} shipping
            </div>
          )}
        </div>

        <div style={styles.cardPriceRow}>
          <span style={styles.cardPrice(colors)}>
            {money(item.effective_price || item.price_customer)}
          </span>
        </div>

        <button
          type="button"
          disabled={!canBuyDirect || addingTo === item.id || added}
          onClick={
            needsVariantPick && phase === "open"
              ? onOpen
              : onAdd
          }
          style={styles.cardBtn(colors, canBuyDirect, added, needsVariantPick)}
        >
          {added ? (
            <>
              <Check size={14} /> Added
            </>
          ) : addingTo === item.id ? (
            <>
              <RefreshCw
                size={14}
                style={{ animation: "spin 0.9s linear infinite" }}
              />{" "}
              Adding…
            </>
          ) : (
            <>
              {needsVariantPick ? <Layers size={14} /> : <ShoppingBag size={14} />}
              {phase === "upcoming"
                ? "Not yet open"
                : phase === "closed"
                ? "Window closed"
                : soldOut
                ? "Sold out"
                : needsVariantPick
                ? "Choose options"
                : "Join pre-order"}
            </>
          )}
        </button>
      </div>
    </article>
  );
};

const StatChip = ({ icon: Icon, label, colors }) => (
  <span
    style={{
      display: "inline-flex",
      alignItems: "center",
      gap: 6,
      padding: "6px 11px",
      borderRadius: 999,
      background: colors.raisedBg,
      border: `1px solid ${colors.border}`,
      color: colors.secondaryText,
      fontSize: 12,
      fontWeight: 600,
    }}
  >
    <Icon size={12} />
    {label}
  </span>
);

/* ══════════════════════════════════════════════════════════
   Styles
   ══════════════════════════════════════════════════════════ */

const styles = {
  pageWrap: {
    maxWidth: 1180,
    margin: "0 auto",
    padding: "16px 16px 64px",
  },
  loadingWrap: (c) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: 340,
    gap: 12,
  }),
  spinner: (c) => ({
    width: 32,
    height: 32,
    border: `3px solid ${c.border}`,
    borderTopColor: c.btnBg,
    borderRadius: "50%",
    animation: "spin 0.9s linear infinite",
  }),
  backBtn: (c) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    background: "transparent",
    border: "none",
    color: c.secondaryText,
    cursor: "pointer",
    padding: "6px 0",
    marginBottom: 14,
    fontSize: 13,
    fontWeight: 600,
  }),

  hero: (c) => ({
    background: c.raisedBg,
    border: `1px solid ${c.border}`,
    borderRadius: 18,
    padding: "22px 24px",
    display: "flex",
    flexDirection: "column",
    gap: 14,
  }),
  heroTop: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    flexWrap: "wrap",
  },
  heroChip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "5px 12px",
    borderRadius: 999,
    fontSize: 11.5,
    fontWeight: 700,
    letterSpacing: 0.2,
  },
  heroMeta: (c) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    fontSize: 12.5,
    color: c.secondaryText,
  }),
  heroTitle: (c) => ({
    margin: 0,
    fontSize: "clamp(22px, 3.4vw, 30px)",
    fontWeight: 800,
    letterSpacing: "-0.02em",
    lineHeight: 1.15,
    color: c.heading,
  }),
  heroDesc: (c) => ({
    margin: 0,
    fontSize: 14,
    lineHeight: 1.6,
    color: c.secondaryText,
    maxWidth: 640,
  }),
  heroStats: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    marginTop: 4,
  },

  banner: (c, tone) => ({
    display: "flex",
    alignItems: "flex-start",
    gap: 10,
    padding: "10px 14px",
    borderRadius: 10,
    background: c.hoverBg,
    color: c.secondaryText,
    fontSize: 12.5,
    lineHeight: 1.5,
    marginTop: 4,
  }),

  gridHeader: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    gap: 10,
    marginBottom: 14,
  },
  gridTitle: (c) => ({
    margin: 0,
    fontSize: 15,
    fontWeight: 800,
    color: c.heading,
    letterSpacing: "-0.01em",
  }),
  gridCount: (c) => ({
    fontSize: 12.5,
    color: c.secondaryText,
  }),
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(230px, 1fr))",
    gap: 16,
  },
  emptyGrid: (c) => ({
    padding: "40px 24px",
    textAlign: "center",
    color: c.secondaryText,
    border: `1px dashed ${c.border}`,
    borderRadius: 14,
  }),

  card: (c) => ({
    background: c.raisedBg,
    border: `1px solid ${c.border}`,
    borderRadius: 14,
    overflow: "hidden",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    transition:
      "transform 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  }),
  cardMedia: (c) => ({
    position: "relative",
    aspectRatio: "4 / 3",
    background: c.hoverBg,
    overflow: "hidden",
  }),
  cardImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  },
  cardImgPlaceholder: (c) => ({
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: c.secondaryText,
  }),
  cardBody: {
    padding: 14,
    display: "flex",
    flexDirection: "column",
    gap: 8,
    flex: 1,
  },
  cardTitle: (c) => ({
    margin: 0,
    fontSize: 14.5,
    fontWeight: 700,
    color: c.heading,
    lineHeight: 1.35,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    minHeight: 38,
  }),
  variantChip: (c) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    marginTop: 6,
    padding: "2px 8px",
    borderRadius: 999,
    background: `${c.btnBg}18`,
    color: c.btnBg,
    fontSize: 10.5,
    fontWeight: 700,
    letterSpacing: 0.2,
  }),
  shippingHint: (c) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 4,
    marginTop: 6,
    fontSize: 10.5,
    color: c.secondaryText,
    fontWeight: 600,
  }),
  cardPriceRow: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between",
    gap: 6,
    marginTop: "auto",
  },
  cardPrice: (c) => ({
    fontSize: 18,
    fontWeight: 800,
    color: c.heading,
    letterSpacing: "-0.02em",
  }),
  cardBtn: (c, enabled, added, needsVariantPick) => ({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    padding: "9px 12px",
    borderRadius: 10,
    border: "none",
    background: added ? c.successBg : enabled ? c.btnBg : c.hoverBg,
    color: added ? c.success : enabled ? c.btnText : c.secondaryText,
    fontSize: 13,
    fontWeight: 700,
    cursor: enabled ? "pointer" : "not-allowed",
    transition: "transform 0.15s ease, background 0.15s ease",
  }),

  errorWrap: (c) => ({
    maxWidth: 380,
    margin: "60px auto",
    textAlign: "center",
    padding: 24,
  }),
  errorIcon: (c) => ({
    width: 64,
    height: 64,
    borderRadius: 20,
    background: c.hoverBg,
    color: c.secondaryText,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 16,
  }),
  errorTitle: (c) => ({
    margin: "0 0 6px",
    fontSize: 18,
    fontWeight: 800,
    color: c.heading,
  }),
  errorText: (c) => ({
    margin: "0 0 22px",
    fontSize: 13.5,
    color: c.secondaryText,
    lineHeight: 1.55,
  }),
  primaryBtn: (c) => ({
    padding: "11px 20px",
    borderRadius: 10,
    border: "none",
    background: c.btnBg,
    color: c.btnText,
    fontWeight: 700,
    fontSize: 13.5,
    cursor: "pointer",
  }),
};